import * as React from 'react';

import {
  BaseFileInputProps,
  WrappedFileInputProps
} from 'shared/entities/components/Input';

type Props = WrappedFileInputProps & {
  render: (params: BaseFileInputProps) => React.ReactElement;
};

const BaseFileInput: React.FC<Props> = ({
  onChange,
  render,
  ...rest
}: Props) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = e.target;
      if (files) {
        onChange(files);
      }

      e.target.value = '';
    },
    [onChange]
  );

  return render({
    ...rest,
    onChange: handleChange
  });
};

export default React.memo(BaseFileInput);
